import { Table, Text } from '@mantine/core';
import { useProfile } from 'init/index';
import { type TranslateFunction, tKeys } from 'locales/index';
import { CollaboratorNameCell } from 'modules/Settings/Collaborators/CollaboratorRow/CollaboratorNameCell';
import type { User } from 'shared/hooks/use-load-users';
import { useGetConstants } from 'shared/utils/selectors';

type ActiveCollaboratorProps = {
  user: User;
  onClickRow: () => void;
};

export const ActiveCollaborator = ({ user, onClickRow }: ActiveCollaboratorProps) => {
  const { user_roles: userRoles } = useGetConstants();
  const { id: currentUserId } = useProfile();

  const { id, roles, isAdmin } = user;
  const findRole = (role: string) => userRoles.find(({ value }) => value === role);
  const isCurrentUser = id === currentUserId;

  return (
    <Table.Tr
      onClick={isCurrentUser ? undefined : onClickRow}
      style={{ cursor: isCurrentUser ? 'default' : 'pointer' }}
    >
      <Table.Td w={50}>
        <Text size="sm" c="dimmed">
          {id}
        </Text>
      </Table.Td>
      <Table.Td>
        <CollaboratorNameCell user={user} />
      </Table.Td>
      <Table.Td>
        {(() => {
          if (isAdmin) return <Text size="sm">{findRole('admin')?.description}</Text>;
          return (
            <Text size="sm" maw={600}>
              {roles.map(role => findRole(role)?.description).join(', ')}
            </Text>
          );
        })()}
      </Table.Td>
    </Table.Tr>
  );
};

export function getActiveTableHeaders(t: TranslateFunction) {
  return [
    { title: 'ID' },
    { title: t(tKeys.SETTINGS.STAFF.COLLABORATOR_NAME) },
    { title: t(tKeys.SETTINGS.STAFF.PERMISSIONS) },
  ];
}
